import { render } from "./PlayerPointsCardV2.vue?vue&type=template&id=71514109&scoped=true"
import script from "./PlayerPointsCardV2.vue?vue&type=script&lang=js"
export * from "./PlayerPointsCardV2.vue?vue&type=script&lang=js"

import "./PlayerPointsCardV2.vue?vue&type=style&index=0&id=71514109&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71514109"]])

export default __exports__